import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZFirmwareStopCampaignApiResponse = z.object({
  http_status: z.number(),
  data: z.boolean(),
  error: z.boolean()
})

const ZFirmwareStopCampaignErrorApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  error_message: z.optional(z.string())
})

export type FirmwareStopCampaignApiResponse = z.infer<typeof ZFirmwareStopCampaignApiResponse>
export type FirmwareStopCampaignErrorApiResponse = z.infer<typeof ZFirmwareStopCampaignErrorApiResponse>

export async function firmwareStopCampaign (
  firmwareCampaignId: string,
  onSuccess: (StopStatusData: boolean, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = `/asset-config-service/api/v1/udp/firmwareCampaign/stop-firmware-campaign/${firmwareCampaignId}`
  interceptedAxios
    .put(url)
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZFirmwareStopCampaignApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (
            parseResponse.data.data !== null &&
            parseResponse.data.data !== undefined
          ) {
            onSuccess(parseResponse.data.data, response.status)
          } else {
            onFailure('Error occurred while processing response', response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      } else {
        onFailure(response.statusText, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        const parseResponse = ZFirmwareStopCampaignErrorApiResponse.safeParse(error.response.data)
        if (parseResponse.success) {
          onFailure(parseResponse.data.error_message !== undefined ? parseResponse.data.error_message : '', error.response.status)
        } else {
          onFailure('Parsing Error', error.response.status)
        }
      } else {
        onFailure('Network Error', 0)
      }
    })
}
